angular.module('picmonic-common').directive('stateSelect', [
  'CountryStateConfig',
  function (CountryStateConfig) {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        class: '@',
      },
      link: function (scope, element, attrs) {
        scope.states = CountryStateConfig.states;

        scope.onChange = function () {
          if (scope.ngModel === null) {
            scope.ngModel = '';
          }
        };
      },
      template:
        '<select ng-attr-class="{{class}}" ng-model="ngModel" ng-change="onChange()" ng-options="state.name as state.name for state in states | orderBy: \'name\'"><option value="">Select</option></select>',
    };
  },
]);
